import React, { Component } from 'react';
import { Result, Button } from 'antd';

class ErrorGeneral extends Component {
	componentDidMount() {
		document.title = "Something Went Wrong | Partner Portal";
	}

	render() {
		return (
			<Result
				status="warning"
				title="Something Went Wrong"
				subTitle={this.props.message}
				type={this.props.type}
				extra={(this.props.type && this.props.type === 'modal') ? null : <Button type="primary" key="console" onClick={e => { e.preventDefault(); this.props.history.goBack(); }}>Back</Button>}
			/>
		)
	}
}

export default ErrorGeneral;